/* eslint-disable no-useless-escape */
// define all common constant variables used in project

export const DATE_FORMAT = 'YYYY/MM/DD'

// export const BASE_URL = "http://192.168.1.2:8000/api";
// export const BASE_URL = "http://localhost:8000/api";
export const BASE_URL = process.env.REACT_APP_API_BASE_URL

// export const BASE_URL =  "http://localhost:3000/api";

export const PHONE_PATTERN = new RegExp('^[0-9]*$')
export const PHONE_PATTERN_MESSAGE = 'Please Enter Valid Data!'

// only for numeric value
export const NUMBER_PATTERN = new RegExp('^[0-9]*$')

// only for characters value
// export const CHARACTER_PATTERN = new RegExp("^[a-zA-Z\\s]*$");

export const EMAIL_PATTERN = new RegExp(
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
)

export const API_DATE_FORMAT = 'DD-MM-YYYY'
export const API_ERR_MESSAGE = 'Something went wrong'

// how long a login lasts, in days (keep in sync with SESSION_DAYS in backend AuthServiceProvider)
export const SESSION_DAYS = 7

// user role
export const NUTRITIONIST_ROLE = 'Nutritionist'
export const ROLE_KEYWORD = 'role'
export const ADMIN_ROLE = 'Admin'

// Menu Items
export const ADD_USER = 'Add User'
export const DASHBOARD = 'Dashboard'
export const ADD_PLAN = 'Add Plan'
export const PLANS = 'Plans'
export const USERS = 'Users'

export const CHARACTER_PATTERN = new RegExp(/^[a-zA-Z][a-zA-Z ]*$/)
export const CHARACTER_PATTERN_MESSAGE = 'Please Enter Valid Data!'

export const NUMBER_AND_FRACTIONAL_PATTERN = new RegExp(
    /^(0|[1-9]\d*)(\.\d+)?$/
)
export const NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE = 'Please Enter Valid Data!'

// password rule, kept in sync with backend app/Support/PasswordRules.php
// (use with validateFirst on the Form.Item so only one message shows at a time)
export const PASSWORD_ALLOWED_SYMBOLS = '! @ # $ % ^ & * ( ) _ - + = . , ? / | : ;'
export const PASSWORD_RULES = [
    { min: 8, message: 'Password must be at least 8 characters!' },
    { max: 32, message: 'Password must be at most 32 characters!' },
    { pattern: /^\S*$/, message: 'Password must not contain spaces!' },
    {
        pattern: /^[A-Za-z0-9!@#$%^&*()_\-+=.,?/|:;\s]*$/,
        message: `Password can only contain English letters, digits and ${PASSWORD_ALLOWED_SYMBOLS}`,
    },
    { pattern: /[A-Z]/, message: 'Password must contain at least one uppercase letter!' },
    { pattern: /[0-9]/, message: 'Password must contain at least one digit!' },
]

export const MEASUREMENT_TYPE_IMAGE_BASE_URL =
    process.env.REACT_APP_MEASUREMENT_TYPE_IMAGE_BASE_URL

// account type of the logged-in nutritionist ('Nutritionist (Ayurveda)' or 'Nutritionist General')
// the login page stores the user as { user: {...} }
export const checkLoginUserAccountType = () => {
    try {
        return JSON.parse(localStorage.getItem('user'))?.user?.type_of_account
    } catch (e) {
        return undefined
    }
}

// time slots a patient can prefer to be called in ("7 AM - 8 AM" ... "9 PM - 10 PM")
const hourLabel = (hour) => `${hour % 12 || 12} ${hour < 12 ? 'AM' : 'PM'}`
export const CALL_TIME_SLOTS = Array.from({ length: 15 }, (_, i) => `${hourLabel(7 + i)} - ${hourLabel(8 + i)}`)
// stored on the patient as one text, e.g. "8 AM - 9 AM, 6 PM - 7 PM"
export const CALL_TIME_SEPARATOR = ', '
